import { APIHandler } from "../base";

export const fetchTivaToken = () =>
    APIHandler.get("/auth/tivaToken", {
        withCredentials: true
    });

export const logout = () => APIHandler.post("/auth/logout", undefined, { withCredentials: true });

export const getAzureSpeachToken = () => APIHandler.get("/azurespeach/token");

export const registerFirebase = (data: object) =>
    APIHandler.post("/admin/auth/registerFirebase", data);

export const sendVerificationEmail = (loginUrl: string) =>
    APIHandler.post("/admin/auth/send-verification-email", { loginUrl });

export const sendPasswordReset = (email: string, loginUrl: string) =>
    APIHandler.post("/admin/auth/send-password-reset", { email, loginUrl });
